import { FormMapping } from '@app/utils/form-mapping/decorators/form-mapping';
import { FormMappingAttribute } from '@app/utils/form-mapping/decorators/form-mapping-attribute';
import { Local } from '@app/utils/form-mapping/helpers/default-attributes';
import { FormMappingModel } from '@app/utils/form-mapping/models/form-mapping-model';

@FormMapping()
export class TranslationFormModel extends FormMappingModel {
  @Local
  @FormMappingAttribute({
    parseFunction: (value, o) => {
      return o.key;
    },
  })
  key: string;

  @FormMappingAttribute({
    parseFunction: (value, o) => {
      return o.override;
    },
  })
  override: string;

  @FormMappingAttribute({
    parseFunction: (value, o) => {
      return o.value;
    },
  })
  value: string;
}
